import validate from "/usr/src/app/content/n3-promos-229c896d-d32b-49e7-b8bd-a89fe35b27d5/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-229c896d-d32b-49e7-b8bd-a89fe35b27d5/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}